// Scoped Grommet theme for long-form prose pages (privacy, terms, etc.).
// Apply via <ProseTheme>...</ProseTheme> around content.
import React from "react";
import styled from "styled-components";
import {ThemeContext} from "grommet";
import {deepMerge} from "grommet/utils";

const proseTheme = {
    paragraph: {
        medium: {
            size: '18px',
            height: '1.65',
            maxWidth: 'none',
        },
        extend: () => `
            margin: 0 0 16px;
            max-width: none;
            @media (min-width: 768px) {
                font-size: 19px;
            }
        `,
    },
    heading: {
        responsiveBreakpoint: undefined,
        level: {
            '1': {
                medium: { size: '52px', height: '1.05' },
            },
            '2': {
                medium: { size: '28px', height: '1.2' },
            },
            '4': {
                medium: { size: '22px', height: '1.3' },
            },
        },
        extend: ({level}) => {
            const lvl = Number(level);
            if (lvl === 1) {
                return `
                    margin: 0 0 8px;
                    letter-spacing: -0.5px;
                    max-width: none;
                    @media (min-width: 768px) {
                        font-size: 72px;
                        line-height: 1.05;
                        letter-spacing: -1.5px;
                    }
                `;
            }
            if (lvl === 2) {
                return `
                    margin: 40px 0 4px;
                    max-width: none;
                    @media (min-width: 768px) {
                        font-size: 36px;
                    }
                `;
            }
            if (lvl === 4) {
                return `
                    margin: 24px 0 4px;
                    max-width: none;
                    @media (min-width: 768px) {
                        font-size: 24px;
                    }
                `;
            }
            return 'max-width: none;';
        },
    },
    text: {
        large: { size: '20px', height: '1.5' },
    },
};

export default proseTheme;

const ProseWrapper = styled.div`
    & ul, & ol {
        margin: 0 0 16px;
        padding-left: 1.5em;
    }
    & li {
        font-size: 18px;
        line-height: 1.65;
        margin-bottom: 8px;
    }
    @media (min-width: 768px) {
        & li {
            font-size: 19px;
        }
    }
`;

export const ProseTheme = ({children}) => (
    <ThemeContext.Consumer>
        {(theme) => (
            <ThemeContext.Provider value={deepMerge(theme, proseTheme)}>
                <ProseWrapper>{children}</ProseWrapper>
            </ThemeContext.Provider>
        )}
    </ThemeContext.Consumer>
);

